<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- ── Breadcrumb ─────────────────────────────────────────────── -->
    <div class="mb-2">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link to="/clasdiag">Clasificación de Diagnósticos</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ datoClasDiag.codigo || p_idClasDiag }}
          </li>
        </ol>
      </nav>
    </div>
    <hr />

    <!-- ══════════════════════════════════════════════════════════════
         MASTER — Formulario de Clasificación de Diagnóstico
    ═══════════════════════════════════════════════════════════════ -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <form>
          <!-- ID (solo edición) -->
          <div class="mb-3" v-if="btnEditar">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">ID</label></div>
              <div class="col-10">
                <input type="text" class="form-control" v-model="datoClasDiag.idClasDiag" disabled />
              </div>
            </div>
          </div>
          <!-- Código -->
          <div class="mb-3">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">Código</label></div>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="datoClasDiag.codigo"
                  style="text-transform:uppercase"
                  required
                />
              </div>
            </div>
          </div>
          <!-- Nombre -->
          <div class="mb-3">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="datoClasDiag.nombre"
                  style="text-transform:uppercase"
                  required
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer d-flex gap-2">
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="guardarClasDiag"
          v-if="btnCrear"
        >
          <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
          Guardar
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click.prevent="actualizarClasDiag"
          v-if="btnEditar"
        >
          <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
          Actualizar
        </button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         DETAIL — Diagnósticos de esta clasificación
    ═══════════════════════════════════════════════════════════════ -->
    <h5 class="mb-3">
      <span class="material-icons align-middle me-1" style="font-size:20px">list_alt</span>
      Diagnósticos
    </h5>

    <DataTable
      :data="diagnosticos"
      :columns="columnasDet"
      idField="idDiagnostico"
      mensajeVacio="No hay diagnósticos para esta clasificación."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      @refresh="getDiagnosticos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idDiagnostico)"
      @delete="row => deleteDiagnostico(row.idDiagnostico)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Estado con badge -->
      <template #cell-estado="{ row }">
        <span class="badge" :class="row.estado == 1 ? 'bg-success' : 'bg-secondary'">
          {{ row.estado == 1 ? 'Activo' : 'Inactivo' }}
        </span>
      </template>
    </DataTable>

    <!-- ── Modal Diagnóstico ──────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- IDs (solo edición) -->
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">ID Diagnóstico</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoDiagnostico.idDiagnostico" disabled />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">ID Clas. Diag</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoDiagnostico.idClasDiag" disabled />
                  </div>
                </div>
              </div>
              <!-- Código -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Código</label></div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoDiagnostico.codigo"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      v-model="datoDiagnostico.nombre"
                      style="text-transform:uppercase"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarDiagnostico"
              v-if="btnCrear_det"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarDiagnostico"
              v-if="btnEditar_det"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "ClasDiagForm",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      // ── Master ──────────────────────────────────────────────
      p_idClasDiag:  "",
      datoClasDiag:  {},
      btnCrear:      false,
      btnEditar:     false,

      // ── Detail ──────────────────────────────────────────────
      diagnosticos:    [],
      datoDiagnostico: {},
      nombreBusqueda:  "",
      titulo:          "",
      btnCrear_det:    false,
      btnEditar_det:   false,
      modalWindow:     true,
    };
  },

  computed: {
    columnasDet() {
      return [
        { label: "Código", field: "codigo" },
        { label: "Nombre", field: "nombre" },
        // estado usa slot #cell-estado para badge
        { label: "Estado", field: "estado" },
      ];
    },
  },

  mounted() {
    this.p_idClasDiag = this.$route.params.p_idclasdiag;
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarMaster();
    this.getDiagnosticos();
  },

  methods: {
    // ── Master ────────────────────────────────────────────────
    async cargarMaster() {
      if (!this.p_idClasDiag) return;
      try {
        const resp         = await api.get("/vwclasdiags/" + this.p_idClasDiag);
        this.datoClasDiag  = resp.data;
        this.btnCrear      = false;
        this.btnEditar     = true;
      } catch (e) {
        console.error("Error al cargar clasificación:", e);
      }
    },

    validarFormMaster() {
      if (!this.datoClasDiag.codigo) {
        Swal.fire({ icon: "error", title: "Error", text: "El código no puede ser nulo." });
        return 0;
      }
      if (!this.datoClasDiag.nombre) {
        Swal.fire({ icon: "error", title: "Error", text: "El nombre no puede ser nulo." });
        return 0;
      }
      return 1;
    },

    async guardarClasDiag() {
      if (this.validarFormMaster() !== 1) return;
      try {
        await api.post("/clasdiags", this.datoClasDiag);
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Clasificación creada exitosamente." });
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarClasDiag() {
      if (this.validarFormMaster() !== 1) return;
      try {
        await api.post("/clasdiags", this.datoClasDiag);
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Clasificación actualizada exitosamente." });
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    // ── Detail — carga de datos ───────────────────────────────
    async getDiagnosticos() {
      this.nombreBusqueda = "";
      try {
        const r          = await api.get(`/vwdiagnosticos/idclasdiag/${this.p_idClasDiag}`);
        this.diagnosticos = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        console.error("Error al cargar diagnósticos:", e);
      }
    },

    async getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getDiagnosticos(); return; }
      try {
        const r          = await api.get(`/vwdiagnosticos/nombre/${nombre}`);
        this.diagnosticos = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        console.error("Error al buscar diagnóstico:", e);
      }
    },

    // ── Detail — validación ───────────────────────────────────
    validarFormDet() {
      if (!this.datoDiagnostico.codigo) {
        Swal.fire({ icon: "error", title: "Error", text: "El código no puede ser nulo." });
        return 0;
      }
      if (!this.datoDiagnostico.nombre) {
        Swal.fire({ icon: "error", title: "Error", text: "El nombre no puede ser nulo." });
        return 0;
      }
      return 1;
    },

    // ── Detail — CRUD ─────────────────────────────────────────
    async guardarDiagnostico() {
      if (this.validarFormDet() !== 1) return;
      try {
        this.datoDiagnostico.idClasDiag = this.datoClasDiag.idClasDiag;
        await api.post("/diagnosticos", this.datoDiagnostico);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Diagnóstico creado exitosamente." });
        this.getDiagnosticos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarDiagnostico() {
      if (this.validarFormDet() !== 1) return;
      try {
        await api.post("/diagnosticos", this.datoDiagnostico);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Diagnóstico actualizado exitosamente." });
        this.getDiagnosticos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteDiagnostico(idDiagnostico) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar diagnóstico?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/diagnosticos/" + idDiagnostico);
        this.getDiagnosticos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Detail — modales ──────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow    = true;
      this.datoDiagnostico = { idClasDiag: this.datoClasDiag.idClasDiag };
      this.titulo         = "Crear Diagnóstico";
      this.btnCrear_det   = true;
      this.btnEditar_det  = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idDiagnostico) {
      this.modalWindow   = true;
      this.titulo        = "Editar Diagnóstico";
      this.btnCrear_det  = false;
      this.btnEditar_det = true;
      try {
        const resp           = await api.get("/vwdiagnosticos/" + idDiagnostico);
        this.datoDiagnostico = resp.data;
      } catch (e) {
        console.error("Error al cargar diagnóstico:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
  },
};
</script>